import { Select } from "../Base/Select/index";

const FirmFilter = ({ handleFirmChange, values }) => {
  return (
    <div style={{ height: "100px" }}>
      <Select
        options={
          (values?.length &&
            values?.map((state) => ({
              label: `${state.name}`,
              value: `${state.id}`,
            }))) ||
          []
        }
        defaultValue={
          values?.length ? values?.find((data) => data.isSelected)?.id : ""
        }
        onChange={handleFirmChange}
        label="Choose Firm"
        placeholder="Choose Firm"
        key={1}
      />
    </div>
  );
};

export default FirmFilter;
